/* 
    This Regex accepts Safaricom numbers 
    starting with +2517 | 2517 | 07 | 7
*/
export const phoneRegex = /^(\+?251[7]|0?[7])[0-9]{8}$/